var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "381.221,79.555 350.253,0 51.2,0 51.2,512 460.8,512 460.8,110.523 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.22,202.683c17.453,0,31.595,14.142,31.595,31.595s-14.142,31.595-31.595,31.595 s-31.595-14.142-31.595-31.595S258.767,202.683,276.22,202.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A6E2E3"
    },
    d: "M398.178,168.452V373.82H113.822V168.452H398.178z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFA638"
    },
    d: "M276.22,202.683c17.453,0,31.595,14.142,31.595,31.595s-14.142,31.595-31.595,31.595 s-31.595-14.142-31.595-31.595S258.767,202.683,276.22,202.683z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFA638"
    },
    points: "398.178,358.022 398.178,444.908 240.368,444.908 240.368,360.777 334.148,286.933  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#ED8300"
    },
    points: "240.368,360.777 294.642,444.908 113.822,444.908 113.822,373.819 189.334,281.671 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "460.8,110.523 350.253,110.523 350.253,0 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.0f173d31b405219aa5c8a6afe8cff7f4.svg";
export { ForwardRef as ReactComponent };